<template>
    <span
        v-if="mostrarBtnSolicitarReabertura || mostrarMsgSolicitarReabertura"
        class="ml-2"
    >
        <span v-if="mostrarMsgSolicitarReabertura"
            ><strong
                >Existe uma solicitação de reabertura em processamento</strong
            ></span
        >
        <b-button
            variant="danger"
            @click.stop="abrir()"
            v-if="mostrarBtnSolicitarReabertura"
        >
            <span> <i class="fa fa-refresh"></i> Solicitar Reabertura</span>
        </b-button>
        <b-modal
            id="modalEvento"
            v-model="mostrarModal"
            v-if="mostrarBtnSolicitarReabertura"
        >
            <div slot="modal-title">Entrega - Solicitar Reabertura</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fechar()"
                    >Fechar</b-button
                >
                <b-button
                    variant="danger"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarSolicitacaoReabertura()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-refresh"></i> Solicitar Reabertura</span
                    >
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { entregaStatus } from './EntregaStatus'
import { contratacaoSituacoes } from '../contratacoes/ContratacaoSituacoes'

export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        entregasServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            justificativa: null
        }
    },

    methods: {
        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
            this.justificativa = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        confirmarSolicitacaoReabertura() {
            this.$swal({
                title: 'Solicitação de Reabertura',
                html: `Confirma a solicitação de reabertura da entrega?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.solicitarReabertura()
                }
            })
        },

        solicitarReabertura() {
            this.$store.dispatch('addRequest')
            let solicitacaoReaberturaDto = {
                entregaId: this.$route.params.entregaId,
                justificativa: this.justificativa
            }
            this.entregasServicos
                .solicitarReabertura(solicitacaoReaberturaDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Solicitação de Reabertura realizada com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.fechar()
                            this.$emit('obterEntregaAtualizada')
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnSolicitarReabertura() {
            return (
                this.$temAcesso('CRED-GEST-ENTR-06') &&
                this.entrega?.contratacao?.situacao !==
                    contratacaoSituacoes.CANCELADA &&
                this.entrega?.contratacao?.situacao !==
                    contratacaoSituacoes.DISTRATO &&
                (this.entrega?.status === entregaStatus.APROVADA ||
                    this.entrega?.status ===
                        entregaStatus.CANCELADA_SEM_PAGAMENTO ||
                    this.entrega?.status ===
                        entregaStatus.CANCELADA_COM_PAGAMENTO) &&
                !this.entrega?.temSolicitacaoReaberturaAtiva &&
                !this.entrega?.pagamentoFaturado
            )
        },

        mostrarMsgSolicitarReabertura() {
            return (
                this.$temAcesso('CRED-GEST-ENTR-06') &&
                (this.entrega?.status === entregaStatus.APROVADA ||
                    this.entrega?.status ===
                        entregaStatus.CANCELADA_SEM_PAGAMENTO ||
                    this.entrega?.status ===
                        entregaStatus.CANCELADA_COM_PAGAMENTO) &&
                this.entrega?.temSolicitacaoReaberturaAtiva
            )
        }
    },

    created() {},

    watch: {},

    validations: {
        justificativa: {
            required
        }
    }
}
</script>
